module.exports = require("./fr-GF.d.ts");